@if (modalOpen()) {
  <div
    class="fixed inset-0 z-1999 flex items-center justify-center overflow-y-auto bg-slate-950/50 p-4 backdrop-blur-sm"
    (click)="closeModal()"
  >
    <section
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-modal-title"
      class="my-auto w-full max-w-xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <!-- CABECERA DEL MODAL -->
      <header
        class="flex items-center justify-between border-b border-slate-100 px-6 py-5"
      >
        <div class="flex items-center gap-3">
          <div
            class="flex size-10 items-center justify-center rounded-xl bg-blue-50 text-primary-600"
          >
            <svg
              class="size-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.8"
                d="M12 3 5 6v5c0 4.5 3 8 7 10 4-2 7-5.5 7-10V6l-7-3Z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.8"
                d="m9 12 2 2 4-4"
              />
            </svg>
          </div>

          <div>
            <h2 id="session-modal-title" class="font-bold text-slate-900">
              Administrar sesiones
            </h2>

            <p class="mt-0.5 text-xs text-slate-500">Seguridad de tu cuenta</p>
          </div>
        </div>

        <button
          type="button"
          (click)="closeModal()"
          aria-label="Cerrar modal"
          class="rounded-lg p-2 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
        >
          <svg
            class="size-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m6 6 12 12M18 6 6 18"
            />
          </svg>
        </button>
      </header>

      <div class="p-6">
        <!-- PASO 1: VERIFICACIÓN -->
        @if (step() === 'verify') {
          <c-verify-twofa
            [requestCode]="requestCode()"
            (onVerificationResult)="$event && (verifiedSuccess())"
          />
        }

        <!-- PASO 2: ADMINISTRACIÓN -->
        @if (step() === 'sessions') {
          <div class="space-y-4">
            <div class="flex items-start gap-3 rounded-xl bg-emerald-50 p-4">
              <svg
                class="mt-0.5 size-5 shrink-0 text-emerald-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="9" stroke-width="1.8" />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m8 12 2.5 2.5L16 9"
                />
              </svg>

              <div>
                <p class="text-sm font-semibold text-emerald-900">
                  Acceso a la administración
                </p>

                <p class="mt-1 text-sm text-emerald-800">
                  Revisá tus dispositivos y cerrá cualquier sesión que no
                  reconozcas.
                </p>
              </div>
            </div>

            <div class="max-h-[55vh] space-y-3 overflow-y-auto">
              @for (session of sessions(); track session.id) {
                <article
                  class="flex items-start gap-3 rounded-xl border border-slate-200 p-4"
                >
                  <div
                    class="flex size-10 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-lg text-slate-700"
                  >
                    {{ deviceIcon(session.deviceType) }}
                  </div>

                  <div class="min-w-0 flex-1">
                    <p
                      class="wrap-break-word text-sm font-semibold text-slate-900"
                    >
                      {{ session.deviceName }}
                    </p>

                    <p class="mt-1 text-xs text-slate-500">
                      {{ session.where || 'Ubicación desconocida' }}
                    </p>

                    <p class="mt-1 text-xs text-slate-500">
                      Última actividad:
                      {{ session.lastActivityAt | date: 'dd/MM/yyyy, HH:mm' }}
                    </p>

                    <div class="mt-3 flex flex-wrap items-center gap-2">
                      @if (session.revokedAt) {
                        <span
                          class="rounded-full bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700"
                        >
                          Revocada
                        </span>
                      } @else {
                        <span
                          class="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700"
                        >
                          Activa
                        </span>

                        @if (session.refreshTokenHash === currentSessionId()) {
                          <span
                            class="rounded-full bg-primary-50 px-2.5 py-1 text-xs font-semibold text-primary-700"
                          >
                            Este dispositivo
                          </span>
                        }
                      }
                    </div>
                  </div>

                  @if (
                    !session.revokedAt &&
                    session.refreshTokenHash !== currentSessionId()
                  ) {
                    <button
                      type="button"
                      (click)="closeSession(session.refreshTokenHash)"
                      class="shrink-0 rounded-lg px-3 py-2 text-xs font-semibold text-red-600 transition hover:bg-red-50"
                    >
                      Cerrar sesión
                    </button>
                  }
                </article>
              } @empty {
                <div class="py-8 text-center text-sm text-slate-500">
                  No hay sesiones registradas.
                </div>
              }
            </div>

            <div class="flex justify-end border-t border-slate-100 pt-4">
              <button
                type="button"
                (click)="closeModal()"
                class="rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                Cerrar
              </button>
            </div>
          </div>
        }
      </div>
    </section>
  </div>
}
